import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Pinwheel.scss';
const Pinwheel = ({ size = 35, color = 'black', speed = 0.9, stroke = 3.5, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + 'px',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.line }), _jsx("div", { className: styles.line }), _jsx("div", { className: styles.line }), _jsx("div", { className: styles.line }), _jsx("div", { className: styles.line }), _jsx("div", { className: styles.line })] }) }));
};
export default Pinwheel;
